(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initReviews(root){
      if(root.dataset.reviewsInit) return;
      root.dataset.reviewsInit = 'true';

      var track   = root.querySelector('.reviews__track');
      var cards   = Array.prototype.slice.call(root.querySelectorAll('.rev-card'));
      var prevBtn = root.querySelector('.reviews__arrow--prev');
      var nextBtn = root.querySelector('.reviews__arrow--next');
      var dotsBox = root.querySelector('.reviews__dots');
      if(!track || !cards.length) return;

      /* Read more / Read less (alleen tonen als de tekst overloopt) */
      cards.forEach(function(card){
        var text = card.querySelector('.rev-card__text');
        var btn  = card.querySelector('.rev-card__toggle');
        if(!text || !btn) return;
        if(text.scrollHeight - text.clientHeight > 2){ btn.style.display = 'block'; }
        btn.addEventListener('click', function(){
          var open = card.classList.toggle('is-open');
          btn.textContent = open ? 'Read less' : 'Read more';
        });
      });

      function step(){
        if(cards.length < 2) return cards[0].offsetWidth;
        return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
      }
      if(prevBtn) prevBtn.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      if(nextBtn) nextBtn.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); });

      /* Dots */
      var dots = [];
      cards.forEach(function(card, i){
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('role','tab');
        dot.setAttribute('aria-label','Go to review ' + (i+1));
        dot.addEventListener('click', function(){
          track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior:'smooth' });
        });
        dotsBox.appendChild(dot);
        dots.push(dot);
      });

      function update(){
        var mid = track.scrollLeft + track.clientWidth/2;
        var active = 0, best = Infinity;
        cards.forEach(function(card, i){
          var center = card.offsetLeft + card.offsetWidth/2 - track.offsetLeft;
          var d = Math.abs(center - mid);
          if(d < best){ best = d; active = i; }
        });
        dots.forEach(function(d, i){ d.classList.toggle('is-active', i === active); });
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        if(prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
        if(nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      var raf;
      track.addEventListener('scroll', function(){
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(){
      document.querySelectorAll('.reviews').forEach(initReviews);
    }

    if(document.readyState === 'loading'){
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    /* Theme editor: opnieuw initialiseren na herladen van de section */
    document.addEventListener('shopify:section:load', function(e){
      e.target.querySelectorAll('.reviews').forEach(initReviews);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
      this._items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (item.open) {
            this._items.forEach((other) => {
              if (other !== item) other.removeAttribute('open');
            });
          }
        });
      });
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
